import { render } from "./PersonalBuildCard.vue?vue&type=template&id=4e0c3717&ts=true"
import script from "./PersonalBuildCard.vue?vue&type=script&lang=ts"
export * from "./PersonalBuildCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__